export const normalizeHttpsUrl = (urlParam: string) => {
  // Test if there is an https:// already included in param
  if (!/^https?:\/\//i.test(urlParam)) {
    return "https://" + urlParam;
  }
  return urlParam;
};
